import { AbstractControl, FormGroup } from '@angular/forms';

import { Numbers } from '../../../../../app/utils/constants';

export default class CalendarUtilsExtended {

  /**
   * constructor
   */
  constructor() {
  }

  public today = new Date();
  public month: number = this.today.getMonth();
  public year: number = this.today.getFullYear();
  public prevMonth = this.month - 1;
  public prevYear: number = this.year;
  public nextMonth = this.month + 1;
  public nextYear: number = this.year;
  public calendarLanguajeEs: any;
  public minY = this.year - Numbers.number70;
  public maxY: number = this.year;
  public minDateV3: any;
  public maxDateV3: any;
  public fieldErrors: any;
  public fieldErrors2: any;
  public fieldErrors3: any;
  readonlyBirth = true;
  public currentInsure: string;


  /**
   * initUtils
   */
  initUtils(): void {
    if (this.month === Numbers.number0) {
      this.prevMonth = Numbers.number11;
    }
    if (this.prevMonth === Numbers.number11) {
      this.prevYear = this.year - Numbers.number1;
    }
    if (this.month === Numbers.number11) {
      this.nextMonth = Numbers.number0;
    }
    if (this.nextMonth === Numbers.number0) {
      this.nextYear = this.year + Numbers.number1;
    }
    this.calendarLanguajeEs = {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sabado'],
      dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sab'],
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
        'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul',
        'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      today: 'Today',
      clear: 'Clear',
      weekHeader: 'Wk'
    };
  }

  /**
   * Metodo que setea el año máximo y mínimo del calendario
   * @param anioMin numero de años minimo del calendario
   * @param anioMax numero de años maximo del calendario
   * @param prevsYear  año actual
   * @param auxMinPrevDate año minimo
   * @param auxMax70Date año maximo
   */
  setMinMaxYear(anioMin: number, anioMax: number, prevsYear: number, auxMinPrevDate: Date, auxMax70Date: Date): void {
    this.minY = this.year - anioMin;
    this.maxY = this.year - anioMax;
    if (prevsYear) {
      auxMax70Date.setFullYear(prevsYear - anioMax);
    }
    this.minDateV3 = auxMinPrevDate;
    this.maxDateV3 = auxMax70Date;
  }

  /**
   * @param controlName field to check erros
   * @param num tipo de campo que se está validando
   * @example 1 - rango incio, 2 - rango fin, 3 - calendario normal
   */
  getErrorUtils(controlName: string, num: any, formData: FormGroup): string {
    let errorMsg = '';
    this.fieldErrors = '';
    this.fieldErrors2 = '';
    this.fieldErrors3 = '';
    if (formData) {
      const CONTROL: AbstractControl = formData.get(controlName);
      if (CONTROL.invalid && CONTROL.errors !== null) {
        errorMsg = JSON.stringify(CONTROL.errors);
        switch (num) {
          case Numbers.number1:
            this.fieldErrors = CONTROL.errors;
            break;
          case Numbers.number2:
            this.fieldErrors2 = CONTROL.errors;
            break;
          case Numbers.number3:
            this.fieldErrors3 = CONTROL.errors;
            break;
          default:
            this.fieldErrors = CONTROL.errors;
            break;
        }
      }
    }
    return errorMsg;
  }

  /**
   * @description Asignación de estilos para el rango de fechas seleccionadas
   */
  stylesCalendar(): void {
    const ELS_2: NodeListOf<Element> = document.querySelectorAll('.ui-datepicker-current-day');
    ELS_2.forEach((ele, idx) => {
      if (idx === 0) {
        ele.classList.add('primer-dia');
      }
      if (idx === (ELS_2.length - 1) && idx !== 0) {
        ele.classList.add('ultimo-dia');
      }
    });
  }

  /**
   * setYears
   * @param typeBorn string
   * @param insureSelected string
   */
  setYears(typeBorn: string, insureSelected: string): void {
    this.readonlyBirth = true;
    if (typeBorn === 'mayor70' || typeBorn === 'mayor60') {
      this.readonlyBirth = false;
    }
    this.minDateV3 = '';
    this.maxDateV3 = '';
    const AUX_MIN_DATE = new Date();
    const PREVS_YEAR: number = AUX_MIN_DATE.getFullYear();
    AUX_MIN_DATE.setFullYear(PREVS_YEAR - Numbers.number80);
    const AUX_MIN_PREV_DATE = new Date(AUX_MIN_DATE);
    AUX_MIN_PREV_DATE.setDate(AUX_MIN_DATE.getDate() + 1);
    const AUX_MAX_70_DATE = new Date();
    if (typeBorn === 'mayor70') {
      if (insureSelected === 'particularTravelAsistance') {
        // Solo para particulares (particularTravelAsistance, AVP, form=3) ya que se amplía el mínimo a 90 años.
        const AUX_MIN_DATE_AVP = new Date();
        AUX_MIN_DATE_AVP.setFullYear(PREVS_YEAR - Numbers.number90);
        const AUX_MIN_PREV_DATE_AVP = new Date(AUX_MIN_DATE_AVP);
        AUX_MIN_PREV_DATE_AVP.setDate(AUX_MIN_DATE_AVP.getDate() + 1);
        this.setMinMaxYear(Numbers.number90, Numbers.number70, PREVS_YEAR, AUX_MIN_PREV_DATE_AVP, AUX_MAX_70_DATE);
      } else {
        // Para otros casos, se mantiene el mínimo a 80 años.
        this.setMinMaxYear(Numbers.number80, Numbers.number70, PREVS_YEAR, AUX_MIN_PREV_DATE, AUX_MAX_70_DATE);
      }
    }
    if (typeBorn === 'mayor60') {
      this.setMinMaxYear(Numbers.number80, Numbers.number60, PREVS_YEAR, AUX_MIN_PREV_DATE, AUX_MAX_70_DATE);
    }
    if (typeBorn !== 'mayor60' && typeBorn !== 'mayor70' &&
      insureSelected === 'incomingStudentsTravelAsistance') {
      this.setMinMaxYear(Numbers.number60, 0, null, AUX_MIN_PREV_DATE, AUX_MAX_70_DATE);
    }
    if (typeBorn !== 'mayor60' && typeBorn !== 'mayor70' &&
      insureSelected !== 'incomingStudentsTravelAsistance') {
      this.setMinMaxYear(Numbers.number70, 0, null, AUX_MIN_PREV_DATE, AUX_MAX_70_DATE);
    }
  }

  /**
   * Check if the current or next year is bisiesto
   * @returns boolean
   */
  checkIsBisiesto(month: any, year: any): boolean {
    let isBisiesto = false;
    const yearPlus = year + 1;

    if (((year % Numbers.number4 === Numbers.number0 && year % Numbers.number100 !== Numbers.number0) ||
    year % Numbers.number400 === Numbers.number0) && (month < Numbers.number2)) {
      isBisiesto = true;
    } else if (((yearPlus % Numbers.number4 === Numbers.number0 && yearPlus % Numbers.number100 !== Numbers.number0) ||
    yearPlus % Numbers.number400 === Numbers.number0) && (month > Numbers.number1)) {
      isBisiesto = true;
    } else {
      isBisiesto = false;
    }

    return isBisiesto;
  }

  /**
   * @ignore
   */
  getCurrentInsure(dataConfig: any): void {
    // Cuando entramos con un calendario normal
    if (dataConfig && dataConfig.linkFormPath && dataConfig.linkFormPath.length > 0) {
      this.currentInsure = dataConfig.linkFormPath[0];
    }
    // Cuando entramos con un formulario de rangos
    if (dataConfig && dataConfig.start && dataConfig.start.linkFormPath &&
        !(dataConfig.linkFormPath && dataConfig.linkFormPath.length > 0)) {
      this.currentInsure = dataConfig.start.linkFormPath[0];
    }
  }

  /**
   * Calculate the max num days
   * @param insureSelected insuredSelect
   * @param isBisiesto is bisiesto year
   * @returns max days num
   */
  calculateMaxNumDays(insureSelected: string, isBisiesto: boolean): number {
    let maxV = 0;
    if (insureSelected === 'individualTravelAsistance') {
      maxV = Numbers.number34 - 1; // 34 días máximo - el dia marcado
    }
    if (insureSelected === 'particularTravelAsistance' || insureSelected === 'sportTravelAsistance') {
      maxV = Numbers.number185 - 1; // 185 días máximo - el primer día
    }
    if (insureSelected === 'incomingStudentsTravelAsistance' && isBisiesto) {
      maxV = Numbers.number365;
    }
    if (insureSelected === 'incomingStudentsTravelAsistance' && !isBisiesto) {
      maxV = Numbers.number364;
    }
    return maxV;
  }
}
